<script>
    import {Link} from 'svelte-routing';
    import {store} from '../stores.js';

    import TopMenu from '../components/TopMenu.svelte';
    import Footer from '../components/Footer.svelte';

    const user = store('credentials', 'appUserAuth');
          user.load({login: $user.email, password: $user.pasport});
    
    let sw = 0;
</script>

<TopMenu title="Личный кабинет" />

<div id="appCapsule">
    <div class="section mb-4">
        <div class="row">
            <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                <div class="profile-head">
                    <div class="avatar">
                        <ion-icon name="school-outline" style="font-size: 64px"></ion-icon>
                    </div>
                    <div class="in">
                        <h3 class="name">{$user.name}</h3>
                        <h5 class="subtext">{$user.gorod}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="section mt-2 mb-4">
        <div class="row">
            <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                <div class="section-title">Ваши успехи</div>
                <div class="profile-stats ps-2 pe-2">
                    <span class="item">
                        <strong>{+($user.testsCount ? $user.testsCount : 0)}</strong>Тестов
                    </span>
                    <span class="item">
                        <strong>{+($user.balance ? $user.balance : 0)}</strong>МИИНки
                    </span>
                    <span class="item">
                        <strong>{+($user.eventsCount ? $user.eventsCount : 0)}</strong>Мероприятий
                    </span>
                    {#if $user.certs > 0}
                        <span class="item">
                            <strong>{+($user.certs ? $user.certs : 0)}</strong>Сертификатов
                        </span>
                    {/if}
                </div>
            </div>
        </div>
    </div>
    
    <div class="section mt-2 mb-4">
        <div class="row">
            <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                <div class="section-title pb-0">Рекомендации</div>
    
    
                {#if $user.ves > 0}
                    <div class="btn-group w-100 mt-1 mb-2 px-1 px-md-0">
                        <input type="radio" class="btn-check" name="btnradio" id="switch-mode-1" bind:group={sw} value={0}>
                        <label class="btn btn-outline-secondary col-6" for="switch-mode-1">Обычный</label>
                        <input type="radio" class="btn-check" name="btnradio" id="switch-mode-2" bind:group={sw} value={1}>
                        <label class="btn btn-outline-primary col-6" for="switch-mode-2">Интенсивный</label>
                    </div>
    
                    <div class="row px-1 px-md-0">
                        <div class="col-6 col-md-3 mx-md-auto">
                            <div class="card text-white {sw ? 'badge-primary' : 'badge-secondary'} mb-2">
                                <div class="card-body text-center">
                                    <h6 class="card-subtitle text-white">Вода</h6>
                                    <h5 class="card-title text-white">{$user.ves * (!sw ? 30 : 40)}мл</h5>
                                    
                                    <p class="card-text">
                                        {$user.ves}кг &times; {(!sw ? 30 : 40)}мл
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-3 mx-md-auto">
                            <div class="card text-white {sw ? 'badge-primary' : 'badge-secondary'} mb-2">
                                <div class="card-body text-center">
                                    <h6 class="card-subtitle text-white">Белки</h6>
                                    <h5 class="card-title text-white">{$user.ves * (!sw ? 1 : 1.5)}г</h5>
                                    
                                    <p class="card-text">
                                        {$user.ves}кг &times; {(!sw ? 1 : 1.5)}г
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-3 mx-md-auto">
                            <div class="card text-white {sw ? 'badge-primary' : 'badge-secondary'} mb-2">
                                <div class="card-body text-center">
                                    <h6 class="card-subtitle text-white">Жиры</h6>
                                    <h5 class="card-title text-white">{$user.ves * (!sw ? 1 : 1)}г</h5>
                                    
                                    <p class="card-text">
                                        {$user.ves}кг &times; {(!sw ? 1 : 1)}г
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-3 mx-md-auto">
                            <div class="card text-white {sw ? 'badge-primary' : 'badge-secondary'} mb-2">
                                <div class="card-body text-center">
                                    <h6 class="card-subtitle text-white">Углеводы</h6>
                                    <h5 class="card-title text-white">{$user.ves * (!sw ? 3 : 4)}г</h5>
                                    
                                    <p class="card-text">
                                        {$user.ves}кг &times; {(!sw ? 3 : 4)}г
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                {:else}
                    <div class="row px-1 px-md-0">
                        <Link to="/member" class="card card-round comment-box my-1" style="color: #4F5050!important;">
                            <div class="card-body">
                                <p class="m-0">
                                    <b>Нет данных</b><br>
                                    Заполните дополнительные поля в анкете для отображения рекомендаций
                                </p>
                            </div>
                        </Link>
                    </div>
                {/if}
            </div>
        </div>
    </div>
    
    
    <div class="section mt-2 mb-4">
        <div class="row px-1 px-md-0">
            <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                <div class="section-title">Быстрый переход</div>
                <div class="row">
                    <div class="col-12 mb-1">
                        <Link to="/events" class="card card-round comment-box my-1" style="color: #4F5050!important;">
                            <div class="card-body">
                                <p class="m-0">
                                    <b>Мероприятия</b><br>
                                    Просматривайте и принимайте участие в мероприятиях в вашем городе
                                </p>
                            </div>
                        </Link>
                    </div>
                    {#if $user.certs > 0}
                        <div class="col-12 mb-1">
                            <Link to="/cert" class="card card-round comment-box my-1" style="color: #4F5050!important;">
                                <div class="card-body">
                                    <p class="m-0">
                                        <b>Сертификаты</b><br>
                                        Полученные после посещения мероприятий
                                    </p>
                                </div>
                            </Link>
                        </div>
                    {/if}
                    <div class="col-12 mb-1">
                        <Link to="/member" class="card card-round comment-box my-1" style="color: #4F5050!important;">
                            <div class="card-body">
                                <p class="m-0">
                                    <b>Анкета</b><br>
                                    Изменяйте информацию о себе поддерживая актуальность ваших данных
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<Footer />
